import React, { useContext, useEffect, useState, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { ConfigProvider, message } from 'antd';
import {
  StyleProvider,
  legacyLogicalPropertiesTransformer,
} from "@ant-design/cssinjs";
import type { Locale } from 'antd/es/locale';
import Main from './pages/Main';
import ResInterceptors from './components/ResInterceptors';
import { getUrlParams } from '@/utils/utils'
import trMessages from './locale/tr'
import ruMessages from './locale/ru'
import enMessages from './locale/en'
import zhMessages from './locale/zh'
import chtMessages from './locale/cht'
import arMessages from './locale/ara'
import ptMessages from './locale/pt'
import vieMessage from './locale/vie'
import frMessage from './locale/fra'

import zhCN from 'antd/locale/zh_CN';
import enGB from 'antd/locale/en_GB'
import ruRu from 'antd/locale/ru_RU'
import zhHK from 'antd/locale/zh_HK'
import Tr from 'antd/locale/tr_TR'
import Ara from 'antd/locale/ar_EG'
import Pt from 'antd/locale/pt_PT'
import Vie from 'antd/locale/vi_VN'
import Fra from 'antd/locale/fr_FR'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ar';
import 'dayjs/locale/en';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/tr';
import 'dayjs/locale/ar'
import 'dayjs/locale/pt'
import 'dayjs/locale/vi'
import 'dayjs/locale/fr'
import accountApi from './api/accountApi'
import commonApi from './api/commonApi';
dayjs.locale('zh-cn')
dayjs.locale('en-gb')
dayjs.locale('ru')
dayjs.locale('zh-hk')
dayjs.locale('tr')
dayjs.locale('th')
dayjs.locale('ar')
dayjs.locale('pt')
dayjs.locale('vi')
dayjs.locale('fr')

message.config({
  maxCount: 1
});

let num: number = 1

const App = () => {
  const [messages, setMessages] = useState<any>({})
  const [lang, setLang] = useState<string>("")
  const [color, setColor] = useState<string>("")
  const [fontColor, setFontColor] = useState<string>('#FFFFFF')
  const langTemp: any = {
    'zh': {
      locale: 'zh-CN',
      antdLocale: zhCN,
      messages: zhMessages.messages
    },
    'en': {
      locale: 'en',
      antdLocale: enGB,
      messages: enMessages.messages
    },
    'ru': {
      locale: 'ru',
      antdLocale: ruRu,
      messages: ruMessages.messages
    },
    'cht': {
      locale: 'cht',
      antdLocale: zhHK,
      messages: chtMessages.messages
    },
    'tr': {
      locale: 'tr',
      antdLocale: Tr,
      messages: trMessages.messages
    },
    'ara': {
      locale: 'ara',
      antdLocale: Ara,
      messages: arMessages.messages
    },
    'pt': {
      locale: 'pt',
      antdLocale: Pt,
      messages: ptMessages.messages
    },
    'vie': {
      locale: 'vi',
      antdLocale: Vie,
      message: vieMessage.messages
    },
    'fra': {
      locale: 'fra',
      antdLocale: Fra,
      message: frMessage.messages
    }
  }
  useEffect(() => {
    let origin = window.location.origin
    // 检查用户是否手动切换过版本
    const userChoice = localStorage.getItem('preferDesktop');
    isModernPhone().then((data: any) => {
      console.log("isMobile:", data)
      if(userChoice && userChoice === 'web') {
        let storageLang = window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : ''
        getLangList()
      }else if(data) {
        const { invitation_code } = getUrlParams()
        if(invitation_code) {
          window.location.href = origin.includes('localhost') ? 'http://localhost:3000/#/' : origin + `/h5_index.html#/subPages4/my/register?invitation_code=${invitation_code}`
        }else {
          window.location.href = origin.includes('localhost') ? 'http://localhost:3000/#/' : origin + '/h5_index.html#/'
        }
      }else {
        let storageLang = window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : ''
        console.log("storageLang1111:", storageLang)
        getLangList()
      }
    })
  }, [])

  
  
  /* const initLang = (): any => {
    let lang: any = 'zh'
    if(window.localStorage.getItem('lang')) {
      lang = window.localStorage.getItem('lang')
    }else if(window.navigator.language.includes('zh')) {
      lang = 'zh'
    }else if(window.navigator.language.includes('en')) {
      lang = 'en'
    }else if(window.navigator.language.includes('ru')) {
      lang = 'ru'
    }else if(window.navigator.language.includes('HK') || window.navigator.language.includes('TW')) {
      lang = 'cht'
    }else if(window.navigator.language.includes('tr') || window.navigator.language.includes('TR')) {
      lang = 'tr'
    }
    num && getLangData(lang)
    window.localStorage.setItem('lang', lang)
    return lang
  } */
  const initLang = useMemo(() => {
    let storageLang = window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : ''
    if(storageLang) {
      return storageLang
    }else if(lang) {
      return lang
    }else if(window.navigator.language.includes('zh')) {
      return 'zh'
    }else if(window.navigator.language.includes('en')) {
      return 'en'
    }else if(window.navigator.language.includes('ru')) {
      return 'ru'
    }else if(window.navigator.language.includes('HK') || window.navigator.language.includes('TW')) {
      return 'cht'
    }else if(window.navigator.language.includes('tr') || window.navigator.language.includes('TR')) {
      return 'tr'
    }else if(window.navigator.language.includes('ar')) {
      return 'ara'
    }else if(window.navigator.language.includes('pt')) {
      return 'pt'
    }else if(window.navigator.language.includes('fr')) {
      return 'fra'
    }else {
      return 'zh'
    }
  }, [lang])
  const getColorPrimary = () => {
    let params = {
      lang: localStorage.getItem('lang') || 'zh',
      domain: window.location.host
    }
    accountApi.getSysiting(params).then((res: any) => {
      let res1 = res.data
      if(res1.code === 1) {
        setColor(res1.data.color || '#096BED')
      }
    })
  }
  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }
  const updateObs = () => {
    let langList = Object.keys(langTemp)
    let langUrlList = langList.map((item: string) => {
      return `https://xqpstatics.007vin.com/webshop/locale/cargoweb_${item === 'zh' ? 'cn' : item}.json`
    })
    commonApi.updateObs({
      urls: langUrlList
    }).then((res: any) => {

    })
  }
  const getLangList = () => {
    let params = {
      lang: localStorage.getItem('lang') || 'zh',
      domain: window.location.host
    }
    accountApi.getSysiting(params).then((res: any) => {
      let res1 = res.data
      if(res1.code === 1) {
        setColor(res1.data.color || '#096BED')
        setFontColor(res1.data.font_color || '#FFFFFF')
        let storageLang = window.localStorage.getItem('lang') ? window.localStorage.getItem('lang') : ''
        if(res1.data.languages && res1.data.languages.length) {
          if(storageLang && res1.data.languages.indexOf(storageLang) > -1) {
            let _lang = storageLang
            window.localStorage.setItem('lang', _lang)
            setLang(_lang)
            getLangData(_lang)
            // 根据语言环境设置方向
            document.documentElement.dir = _lang === 'ara' || _lang.toUpperCase() === 'ARA' ? 'rtl' : 'ltr';
          }else {
            let _lang = res1.data.languages[0]
            window.localStorage.setItem('lang', _lang)
            setLang(_lang)
            getLangData(_lang)
            // 根据语言环境设置方向
            document.documentElement.dir = _lang === 'ara' || _lang.toUpperCase() === 'ARA' ? 'rtl' : 'ltr';
          }
          
        }
      }
    })
  }
  
  const getLangData = async (lang: string) => {
    num = 0
    // let oldRes = await accountApi.getLangData({ xqpLang:  lang })
    /* let newRes = await accountApi.getNewLangData({ xqpLang:  lang === 'zh' ? 'cn' : lang, source: 'cargoweb' })
    let _Messages = {}
    if(newRes.data.code === 1) {
      _Messages = {..._Messages, ...newRes.data.data}
    }
    setMessages({..._Messages}) */
    // updateObs()
    fetch(`https://xqpstatics.007vin.com/webshop/locale/cargoweb_${lang === 'zh' ? 'cn' : lang}.json`)
		.then(response => response.json())
		.then(data => {
      setMessages(data)
		})
  }
  if(!Object.keys(messages).length) return null
  return (
    <BrowserRouter basename="/">
      <IntlProvider locale={langTemp[initLang].locale} messages={messages}> 
        <StyleProvider
          hashPriority="high" //要把where删除掉 详细看这个链接 https://ant.design/docs/react/compatible-style-cn
          transformers={[legacyLogicalPropertiesTransformer]}
        >
          <ConfigProvider 
            locale={langTemp[initLang].antdLocale}
            theme={{
              token: {
                colorPrimary: color,
                colorTextLightSolid: fontColor
              }
            }}
          >
            <ResInterceptors/>
            <Main/>
          </ConfigProvider>
        </StyleProvider>
      </IntlProvider>
    </BrowserRouter>
  );
}

export default App;
